<template>
  <div class="bpm-file">
    <div v-for="(item, index) in fileList" :key="index" class="file-item" @click="openFile(item)">
      <!-- <img :src="require('@/assets/form/form-file.png')"> -->
      <i class="el-icon-document" />
      <p> {{ item.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgViewer',
  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    openFile(file) {
      const filePath = file.name
      const index = filePath.lastIndexOf('.')
      // 获取后缀
      const ext = filePath.substr(index + 1)
      if (ext === 'pdf') {
        window.open(file.url, file.name)
      } else {
        try {
          this.download(file.url, file.name)
        } catch (err) {
          window.open(file.url)
        }
      }
      // window.open(file.url, file.name)
    },
    download(url, filename) {
      getBlob(url, function(blob) {
        saveAs(blob, filename)
      })

      function getBlob(url, cb) {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (xhr.status === 200) {
            cb(xhr.response)
          }
        }
        xhr.send()
      }

      function saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename)
        } else {
          var link = document.createElement('a')
          var body = document.querySelector('body')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.style.display = 'none'
          body.appendChild(link)
          link.click()
          body.removeChild(link)
          window.URL.revokeObjectURL(link.href)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .bpm-file {
    .file-item {
      cursor: pointer;
      margin-bottom: 2px;
      display: flex;
      align-items: center;
      padding: 0px 4px;
      border-radius: 4px;
      &:hover {
        color: #2C51EF;
        background-color: #F5F7FA;
        p {
          color: #2C51EF;
        }
      }
      img {
        min-width: 32px;
        min-height: 32px;
        width: 32px;
        height: 32px;
      }
      p {
        padding: 6px 0px;
        flex: 1;
        line-height: 1;
        font-size: 14px;
        padding-left: 7px;
        color: #606266;
        white-space: nowrap;/*内容超宽后禁止换行显示*/
        overflow: hidden;/*超出部分隐藏*/
        text-overflow:ellipsis;/*文字超出部分以省略号显示*/
      }
    }
  }
</style>
